import { useIntl } from 'react-intl'
import TextButton from 'LuxKit/Button/TextButton'
import LineHeartIcon from 'LuxKit/Icons/line/LineHeartIcon'
import Group from 'components/utils/Group'
import { useCallback } from 'react'
import type { TripItem } from 'tripPlanner/types/tripItem'
import * as Analytics from 'analytics/analytics'
import { AnalyticsPage } from 'contexts/Analytics/analyticsPageContext'
import useAddSuggestedItem from 'tripPlanner/hooks/concierge/useAddSuggestedItem'
import { offerIdOrPlaceId } from 'tripPlanner/utils/analytics'
import { addTripIdParam } from 'tripPlanner/utils/url'
import useCanEditTrip from 'tripPlanner/hooks/useCanEditTrip'

interface Props {
  item: TripItem
  offerLink?: string
}

function SuggestionCTAs({ item, offerLink }: Props) {
  const intl = useIntl()
  const { tripId } = item
  const canEdit = useCanEditTrip()
  const onSave = useAddSuggestedItem(item)

  const onView = useCallback(() => {
    const analyticsId = offerIdOrPlaceId(item)
    if (analyticsId) {
      Analytics.trackClientEvent({
        subject: `view_recommended_item_${analyticsId}`,
        action: 'concierge',
        type: 'interaction',
        category: AnalyticsPage.tripPlanner,
      })
    }
  }, [item])

  return (
    <Group
      direction="horizontal"
      verticalAlign="center"
      horizontalAlign="stretch"
      tabletHorizontalAlign="space-between"
      gap={12}
    >
      <TextButton
        kind="tertiary"
        onClick={onSave}
        size="medium"
        startIcon={<LineHeartIcon colour="favourite" />}
      >
        {intl.formatMessage({
          id: 'pkxff5hpGs-m1DA9Y5Ek',
          defaultMessage: 'Save to trip',
          description: 'Button to save a suggested item to the trip in the trip planner',
        })}
      </TextButton>
      {offerLink && <TextButton
        kind="primary"
        to={addTripIdParam(offerLink, tripId, canEdit)}
        target="_blank"
        onClick={onView}
        size="medium"
      >
        {intl.formatMessage({
          id: 'oxWdR_fzXMBczvcdb52e',
          defaultMessage: 'Reserve',
          description: 'Button to reserve a suggested trip item by viewing its offer page',
        })}
      </TextButton>}
    </Group>
  )
}

export default SuggestionCTAs
